import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useInsertMappingProfile = branchGuid => {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const save = (profileGuid, mappingID, cb) => {
    setLoading(true);
    axiosClient
      .post(`Product/Branch/Codding/Mapping/Insert`, {
        branchGuid,
        profileGuid,
        mappingID,
      })
      .then(res => {
        if (res.status === 200) {
          if (cb) {
            cb(res.data.value);
          }
        } else {
          enqueueSnackbar(res.data?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [save, loading];
};

export default useInsertMappingProfile;
